import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';

import { Observable, timer } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { CompanyService } from '../services/company-service';
import { StripeService } from '../services/stripe-service';
import { ICompany } from '../app/_models/company';

@Injectable({ providedIn: 'root' })
export class CompanyValidator {
  constructor(
    public companyService: CompanyService,
    public stripeService: StripeService,
  ) {
  }

  checkIsValidCompanyNameOrCode(code: string) {
    return timer(1000).pipe(
      switchMap(() => this.companyService.isValidCompanyNameOrCode(code)),
    );
  }

  companyValidator(): AsyncValidatorFn {
    return (ctrl: AbstractControl): Observable<{ [key: string]: any } | null> => {
      return this.checkIsValidCompanyNameOrCode(ctrl.value)
        .pipe(
          tap((company: ICompany | null) => {
            if (company) {
              this.companyService.setSelectedCompany(company);
              // Stripe billing is no longer used during registration.
              // this.stripeService.getAllCompanyStripePlans(company.id).subscribe((plans) => {
              //   this.stripeService.setCompanyStripePlans(plans);
              // });
            } else {
              this.companyService.setSelectedCompany({});
              // this.stripeService.clearCompanyStripePlans();
            }
          }),
          map((company: ICompany | null) => {
            if (company) {
              return null;
            }

            if (ctrl.value && ctrl.value.trim().length) {
              return { isInvalidCompanyNameOrCode: true };
            }

            return null;
          }),
        );
    };
  }

}
